import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import MenuCali from '../components/MenuCali';
import Sponsors from '../components/Sponsors';
import TableIndividual from '../components/TableIndividual';
import '../assets/styles/containers/Results.sass';

const Results = () => {
  const [category, setCategory] = useState('');
  const [sponsors, setSponsors] = useState([]);
  const [data, setData] = useState({
    finish: [],
    dnfinish: [],
    ebike: [],
    categories: [],
  });
  const [racers, setRacers] = useState({
    finish: [],
    dnfinish: [],
    ebike: [],
  });
  const showEbikes = category === 'E-BIKE' || category === '';

  useEffect(() =>{
    fetch(`${process.env.REACT_APP_URL}/results/2021/cali`)
    .then(res => res.json())
    .then(res => {
      const finish = res.results.racers.filter((item) => item.dnf === 'N');
      let dnfinish = res.results.racers.filter((item) => item.dnf === 'S');
      dnfinish = dnfinish.sort((a, b) => a.number - b.number);

      setRacers({
        finish: finish,
        dnfinish: dnfinish,
        ebike: res.results.ebike,
      })
      setData({
        finish: finish,
        dnfinish: dnfinish,
        ebike: res.results.ebike,
        categories: res.results.categories,
      })
      setSponsors(res.sponsors);
    })
  }, []);

  const setCategoryState = (category) => {
    setCategory(category);

    if (category === '') {
      return Promise.resolve(
        setData({
          ...data,
          finish: racers.finish,
          dnfinish: racers.dnfinish,
        })
      );
    }

    return Promise.resolve(
      setData({
        ...data,
        finish: racers.finish.filter((item) => item.category_es === category),
        dnfinish: racers.dnfinish.filter((item) => item.category_es === category),
      })
    );
  };

  const setSearchState = (keyword) => {
    if (keyword) {
      return Promise.resolve(
        setData({
          ...data,
          finish: data.finish.filter(racer => racer.racer.includes(keyword.toUpperCase())),
          dnfinish: data.dnfinish.filter(racer => racer.racer.includes(keyword.toUpperCase())),
          ebike: data.ebike.filter(racer => racer.racer.includes(keyword.toUpperCase())),
        })
      )
    }
    return;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let target = event.target

    try {
      await setCategoryState(target.categorias.value)
      if(target.search_racer.value) {
        await setSearchState(target.search_racer.value)
      }
    } catch (error) {
      console.log(error)
    }
  };

  return (
    <Layout>
      <Banner id={11} city="cali" thumb="/cali/logo_cali.PNG" />
      <MenuCali />
      <div className="row content-cali">
        <div className="container">
          <div className="row no-gutters">
            <form onSubmit={handleSubmit} className="results-form">

              <div className="results-form__inputs">
                <div className="results-form__container">
                  <label htmlFor="resultados" className="col-sm-4 ptop">Año</label>
                  <select name="resultados" id="resultados" className="form-control">
                    <option value="2021">2021</option>
                  </select>
                </div>
    
                <div className="results-form__container">
                  <label htmlFor="categorias" className="col-sm-4 ptop">Categoría</label>
                  <select name="categorias" id="categorias" className="form-control">
                    <option value="">TODAS</option>
                    <option value="ABIERTO MASCULINO">ABIERTO MASCULINO</option>
                    <option value="ABIERTO FEMENINO">ABIERTO FEMENINO</option>
                    <option value="MASTER">MASTER</option>
                    <option value="GRANDMASTER">GRANDMASTER</option>
                    <option value="E-BIKE">E-BIKE</option>
                  </select>
                </div>
    
                <div className="results-form__container">
                  <label htmlFor="year" className="col-sm-4 control-label-left">Buscar corredores</label>
                  <input className="form-control" type="text" name="search_racer"/>
                </div>
              </div>
              
              <div className="results-form__cta">
                <button className="results-form__btn --cali" type="submit">VER RESULTADOS</button>
              </div>

            </form>
          </div>

          {data.finish.length > 0 &&
            <>
              <div className="row">
                <div className="col-12">
                  <h1 className="results-form__title">2021 - SERIES CALI - GC - CARRERA {category !== '' && `- ${category}`}</h1>
                </div>
              </div>
              
              <TableIndividual city="cali" racers={data.finish} />
            </>
          }

          {data.dnfinish.length > 0 &&
            <>
              <div className="row">
                <div className="col-12">
                  <h1 className="results-form__title">2021 - SERIES CALI - GC - CARRERA - NO FINALIZADOR {category !== '' && `- ${category}`}</h1>
                </div>
              </div>
              
              <TableIndividual city="cali" racers={data.dnfinish} />
            </>
          }

          {data.ebike.length > 0 && showEbikes &&
            <>
              <div className="row">
                <div className="col-12">
                  <h1 className="results-form__title">2021 - SERIES CALI - GC - CARRERA E-BIKE</h1>
                </div>
              </div>
              
              <TableIndividual city="cali" racers={data.ebike} />
            </>
          }

        </div>
      </div>

      {sponsors.length > 0 &&
        <Sponsors
          customClass="--cali"
          items={sponsors}
        />
      }
    </Layout>
  );
};

export default Results;
